import { createContext } from "react";
import { ChatContextType, AgentState } from "./type";
import { Run } from "../../services/perspective_api/__generated__/perspective_server-types";

const defaultAgentState: AgentState = {
  status: "idle",
  currentIteration: 0,
  maxIterations: 15,
  reasoning: "",
  streamedText: "",
  reasoningHistory: [],
  sqlQueries: [],
  docSearches: [],
  charts: [],
  toolCalls: [],
  genericTables: [],
};

const defaultValue: ChatContextType = {
  isConnected: false,
  messages: [],
  setMessages: () => {},
  sendMessage: () => {},
  connectChat: (run: Run | null, context: string) => {},
  disconnectChat: () => {},
  isAwaitingResponse: false,
  chatSessionId: null,
  chatContext: null,
  agentState: defaultAgentState,
  // Chat history
  chatHistory: [],
  chatHistoryLoading: false,
  fetchChatHistory: () => {},
  loadChatFromHistory: () => {},
  stopCurrentResponse: () => {},
  queuedMessages: 0,
  queuedPrompts: [],
  isStopRequested: false,
};

export const ChatContext = createContext(defaultValue);
